import React from 'react';

import { getLogger } from '../../utils/logger/logger';

interface ErrorBoundaryProps {
  errorDisplay: React.ReactNode;
}

export default class ErrorBoundary extends React.Component<
  React.PropsWithChildren<ErrorBoundaryProps>
> {
  state = { hasError: false };

  constructor(props: ErrorBoundaryProps) {
    super(props);
  }

  static getDerivedStateFromError(error: Error) {
    const hasError = Boolean(error);
    return { hasError };
  }

  componentDidCatch(error: Error) {
    getLogger().error(`error caught in boundary: ${error.message}`, { error });
  }

  render() {
    if (this.state.hasError) {
      return this.props.errorDisplay;
    }
    return this.props.children;
  }
}
